webpackJsonp([162898551421021],{

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Page not found | Razy Technologies' }),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold is-large' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section is-centered' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title' },
	                  '404: NOT FOUND'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'subtitle' },
	                  'You just hit a route that doesn\'t exist... the sadness.'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-668764e0f72bcedfb9e7.js